import { render, staticRenderFns } from "./ConfidenceBinar.vue?vue&type=template&id=24f4ba6a&"
import script from "./ConfidenceBinar.vue?vue&type=script&lang=js&"
export * from "./ConfidenceBinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports